// @ts-strict-ignore
import React from 'react'
import { connect } from 'react-redux'
import { getESProductDataSetData } from '../../../redux/elasticsearch/elasticsearch-selectors'
import { brand } from '../../../redux/app-selectors'
import get from '../../../utils/get'
import { Logo } from './logo'
import { Button } from '../../../atoms'
import { FsCore } from '../../../types/fs-core'
import { isChildOfContainerContext } from '../../helpers/react'
import { ConditionalWrapper } from '../../../utils/conditional-wrapper'

interface PpcNavProps {
  link: string
  jsonBody: any
  brand: string
}

interface PpcProps {
  jsonBody: any
  dataset: any
}

const PpcNav = ({ link, jsonBody, brand }: PpcNavProps) => {
  const href =
    brand === 'money'
      ? 'https://www.money.co.uk'
      : brand === 'confused'
      ? 'https://www.confused.com'
      : 'https://www.uswitch.com'
  return (
    <ConditionalWrapper condition={!!jsonBody?.sticky} wrapper={Container}>
      <div
        className='PpcNav'
        data-sticky-top-nav
        data-sticky-top-nav-is-sticky={jsonBody?.sticky && jsonBody.sticky.toString()}
      >
        <a href={href}>
          <Logo brand={brand} />
        </a>
        {jsonBody?.text && (
          <Button
            size={brand === 'money' ? 'md' : brand === 'confused' ? 'lg' : 'sm'}
            href={link}
            {...jsonBody.buttonProps}
            withIcon={brand === 'confused'}
          >
            {jsonBody.text}
          </Button>
        )}
      </div>
    </ConditionalWrapper>
  )
}

const Container = ({ children }) => (
  <div style={{ width: '100%' }}>
    <isChildOfContainerContext.Provider value={true}>{children}</isChildOfContainerContext.Provider>
  </div>
)

export default connect((state: FsCore.State, props: PpcProps) => {
  let link

  if (props.jsonBody && props.jsonBody.text && props.dataset && props.jsonBody.link) {
    const datasetData = getESProductDataSetData(state, props.dataset.sys.id)?.hits?.hits
    link = get(datasetData?.[0], props.jsonBody.link)
  }

  return {
    ...props,
    link,
    brand: brand(state),
  }
})(PpcNav)
